module.exports = __webpack_public_path__ + "static/media/blog-5.25388307.jpg";